// Dataset simple para la galería de inspiración.
// Colocá las imágenes en /public/showcase/ (o cambia las rutas aquí).
export const SHOWCASE = [
  {
    id: 'lin-01',
    type: 'Recta',
    title: 'Lineal 5 m con heladera, cocina-horno independiente y lavarropas',
    design: '/showcase//1/1.png',   // screenshot del diseño (wire/canvas)
    render: '/showcase/1/1-2.png',   // resultado IA
    caption: 'Frentes lisos, campana oculta.',
  },
  {
    id: 'lin-02',
    type: 'Recta',
    title: 'Lineal 4,5 m con cocina-horno independiente',
    design: '/showcase/2/2.png',
    render: '/showcase/2/2-2.png',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-03',
    type: 'Recta',
    title: 'Lineal 5 m con cocina-horno independiente, heladera y lavarropas',
    design: '/showcase/3/3.png',
    render: '/showcase/3/3-1.png',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-04',
    type: 'Recta',
    title: 'Lineal 5 m con cocina-horno independiente, heladera y lavarropas',
    design: '/showcase/4/4.png',
    render: '/showcase/4/4-1.png',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-05',
    type: 'Recta',
    title: 'Lineal 4,5 m con empotrado, heladera grande',
    design: '/showcase/5/5.png',
    render: '/showcase/5/5-1.png',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-06',
    type: 'Recta',
    title: 'Lineal 4 m con empotrado.',
    design: '/showcase/6/6.png',
    render: '/showcase/6/6-1.png',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-07',
    type: 'Recta',
    title: 'Lineal 4,3 m con empotrado.',
    design: '/showcase/7/7.jpeg',
    render: '/showcase/7/7-1.jpeg',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-08',
    type: 'Recta',
    title: 'Lineal 4,3 m con empotrado.',
    design: '/showcase/8/8.jpeg',
    render: '/showcase/8/8-1.jpeg',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-09',
    type: 'Recta',
    title: 'Lineal 4,1 Tipo Puente con horno y microondas empotrado.',
    design: '/showcase/9/9.png',
    render: '/showcase/9/9-2.png',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-10',
    type: 'Recta',
    title: 'Lineal 4,5 con cocina-horno independiente.',
    design: '/showcase/10/10.png',
    render: '/showcase/10/10-1.png',
    caption: 'Frentes lisos + variación de color en frentes.',
  },
  {
    id: 'lin-11',
    type: 'Recta',
    title: 'Lineal 5 con cocina-horno independiente.',
    design: '/showcase/11/11.png',
    render: '/showcase/11/11-1.png',
    caption: 'Frentes lisos + variación de color en frentes.',
  },


];
